/* BarvoDeka – emoji jako obrázky.
   Fluent Emoji 3D © Microsoft Corporation, licence MIT (https://github.com/microsoft/fluentui-emoji).
   Na iPhonu / iPadu / Macu zůstávají nativní emoji z iPhonu; jinde (Windows, Android)
   se ukáže obrázek ve stejném 3D stylu, ať to všude vypadá stejně. */
(function () {
  'use strict';
  var BD = window.BD || {};
  var EMOJI = '1f308,1f319,1f31f,1f338,1f344,1f37f,1f381,1f383,1f384,1f385,1f389,1f3a8,1f3ac,1f3af,1f3e0,1f3f7,1f436,1f43b,1f43e,1f449,1f44c,1f44d,1f47b,1f496,1f497,1f49c,1f4aa,1f4ac,1f4af,1f4b3,1f4cf,1f4de,1f4e6,1f4e9,1f4fa,1f512,1f525,1f58c,1f58d,1f601,1f60a,1f60d,1f634,1f648,1f64c,1f69a,1f6cb,1f6d2,1f929,1f970,1f973,1f984,1f996,1f9e1,1f9f8,1f9fc,203c,23f0,23f1,2615,26a1,2705,2709,2714,2728,2744,2764,2b50'.split(',');
  var emojiRe = null;
  try { emojiRe = new RegExp('\\p{Extended_Pictographic}\\uFE0F?', 'gu'); } catch (e) { emojiRe = null; }
  function emojify(root) {
    if (!emojiRe || !BD.emojiBase || document.documentElement.classList.contains('is-apple') || !document.createTreeWalker) return;
    root = root || document.body;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      var el = n.parentNode;
      if (!el || /^(SCRIPT|STYLE|TEXTAREA|OPTION|SELECT|TITLE|NOSCRIPT)$/.test(el.nodeName) || (el.closest && el.closest('[data-no-emoji]'))) return NodeFilter.FILTER_REJECT;
      emojiRe.lastIndex = 0;
      return emojiRe.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
    } });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var text = n.nodeValue, frag = document.createDocumentFragment(), last = 0, changed = false, m;
      emojiRe.lastIndex = 0;
      while ((m = emojiRe.exec(text))) {
        var cp = Array.from(m[0].replace(/\uFE0F/g, '')).map(function (c) { return c.codePointAt(0).toString(16); }).join('-');
        if (EMOJI.indexOf(cp) === -1) continue;
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var img = document.createElement('img');
        img.className = 'emo'; img.alt = m[0]; img.draggable = false; img.width = 20; img.height = 20;
        img.src = BD.emojiBase + 'emoji-' + cp + '.png';
        frag.appendChild(img);
        last = m.index + m[0].length; changed = true;
      }
      if (!changed) return;
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }
  emojify(document.body);
  window.BDEmojify = emojify;
})();
